import { render, staticRenderFns } from "./LessonPlan.vue?vue&type=template&id=4841003c&scoped=true"
import script from "./LessonPlan.vue?vue&type=script&lang=js"
export * from "./LessonPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4841003c",
  null
  
)

export default component.exports